// extracted by mini-css-extract-plugin
var _1 = "Icon__Icon___QlWSd";
var _2 = "Icon__clickable___VhzmP";
var _3 = "Icon__less-padding___UCaAG";
var _4 = "Icon__no-fill___TkA2G";
var _5 = "Icon__no-stroke___Mg4rY";
var _6 = "Icon__wiggle___aPbLd";
export { _1 as "Icon", _2 as "clickable", _3 as "less-padding", _4 as "no-fill", _5 as "no-stroke", _6 as "wiggle" }
